import {
    calendarGamePath,
    timeFilterSlug,
} from '@app/router/constants/linkConstants';
import { RouteIdentity } from '@app/router/types';

export const LinkRo: RouteIdentity<string> = {
    App: {
        Home: `/${timeFilterSlug}?`,
        Info: '/info',
        Wiki: '/wiki/:pageSlug',
        NotFound: '/404',
        NotAuthorized: '/401',
        TermsAndConditions: '/termeni-si-conditii',
        CatchAll: '*',
        Shops: '/agentii',
        IdCardVerificationCaptive: '/verify-identity',
        VerifyPhoneCaptive: '/verify-phone',
    },
    Account: {
        Container: '/profil',
        Profile: '', // empty on purpose
        PaymentGatewayStatus: 'static/html/paymentGatewayStatus.html',
        Activate: '/activare-cont',
        PasswordRecovery: '/recuperare-parola',
        ForgotPassword: '/am-uitat-parola',
        Recovery: '/deblocare-cont',
        Register: '/inregistrare',
        ResendActivationEmail: '/resendactivationemail',
        ContinueRegistration: '/pamregistrationcontinueregistrationpageurl',
        Deposit: 'depunere',
        History: 'istoric/:type?',
        Settings: 'setari',
        Withdrawal: 'retragere',
        DocumentUpload: 'incarcare-documente',
        IdentityVerification: 'identity-verification',
        IdentityVerificationUploadAdditional: 'incarcare-document',
        ResponsibleGaming: 'joc-responsabil',
        DepositLimit: 'joc-responsabil/limita-de-depunere',
        BettingLimit: 'joc-responsabil/limita-de-pariere',
        SelfExclusion: 'joc-responsabil/auto-excludere',
        TimeOut: 'joc-responsabil/perioada-de-pauza',
        AccountClosure: 'joc-responsabil/inchidere-cont',
        RealityCheck: '', // not used
        LossLimit: '', // not used
        SessionLimit: '', // not used
        MyMessages: 'mesajele-mele',
        ChangePhone: 'schimbare-numar-de-telefon',
        ReferAFriend: 'refer-a-friend',
        HelpAndSupport: 'ajutor-si-suport',
        ChatPlaceholder: 'chat',
        MySocial: 'profil-social',
        EditMySocial: 'editare-profil-social',
        BlockedUsers: 'utilizatori-blocati',
        MyAccount: 'contul-meu',
        ChangePassword: 'resetare-parola',
        SettingsBetslip: 'bilet',
        SwitchLanguage: 'comutare-de-limba',
        SwitchTheme: 'comutare-de-tema',
        LicencePreferences: 'not-used',
        LoginHistory: 'not-used',
        AccountSecurity: 'securitatea-contului',
    },
    Sport: {
        OfferEvent: '/offer-event/:eventSlug/',
        PrematchOffer: '/pariuri-sportive',
        BetSlip: '/betslip',
        Filter: '/fitrare',
        Search: '/cautare',
        Favourites: '/favorite',
        Category: '/pariuri-sportive/:sportSlug?/:categorySlug?',
        CategoryPerTime: `/pariuri-sportive/:sportSlug?/:categorySlug?/${timeFilterSlug}`,
        SportCompetitions: '/pariuri-sportive/:sportSlug/competitii',
        Competition: `/pariuri-sportive/:sportSlug/:categorySlug/:tournamentSlug/${timeFilterSlug}?`,
        EventRedirect: '/event/:id(\\d+)',
        TournamentRedirect: '/tournament/:id(\\d+)',
        CategoryRedirect: '/category/:id(\\d+)',
        SuperAdvantage: '/super-avantaj/:sportSlug?',
        PriceBoost: '/cote-marite/:sportSlug?',
        MultiEventBetBuilder: '/multi-bet-builder/:sportSlug?',
        PopularBets: '/popular-bets',
        TopWinners: '/big-wins',
        Social: '/pariuri-sportive/:sportSlug/social',
    },
    Lottery: {
        Offer: `/pariuri-loto/${timeFilterSlug}?`,
    },
    News: {
        Feed: '/stiri',
        Article: '/stiri/:articleSlug',
        Articles: '/articole',
    },
    Free2Play: {
        BingoBash: '/bingobash',
        SuperSpin: '/superspin',
        FreeGamesInfo: '/jocurile-superbet',
        SportCaller: '/superprono',
        SuperMillion: '/supermilion',
        CalendarGame: `/${calendarGamePath}`,
        SuperShot: '/supershot',
        TopManager: '/top-manager',
        FantasticDuels: '/super-duel',
    },
    GrowthMarketing: {
        LandingIntro: '/introducere',
        PromotionsInfo: '/promotii-bonusuri',
    },
    Native: {
        AppsFooter: '/footerframe',
        Wiki: '/nativewiki/:pageSlug',
    },
    BonusAndComms: {
        LpBonus: '/primulbonus*',
        PromotionHub: '/promotii-si-bonusuri',
        Notifications: '/notificari',
        MarketingConsent: 'acorduri-de-marketing',
    },
    Loyalty: {
        Supercoins: '/supercoins',
    },
};
